export enum species {
    Dog = 2,
    Cat = 3,
    Rabbit = 4,
    WildlifeStray = 5,
    MultipleAnimals = 6,
    Other = 7
}